import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getCandidate } from "../../../../redux/actions/admin/CandidateActions";
import localStorageService from "../../../../services/localStorageService";
import { CircularProgress } from "@material-ui/core";
import jsPDF from "jspdf";
import moment from "moment";
import "moment/locale/fr";

const ResumeTemplate2 = (props) => {
  const { storeCandidate, getCandidate } = props;
  const [candidateId, setCandidateId] = useState("");
  const [candidate, setCandidate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [initials, setInitials] = useState("");

  useEffect(() => {
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    if (candidate) {
      setCandidateId(candidate?.id);
    }

    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (candidateId != "") {
      if (storeCandidate.candidate === null) {
        setIsLoading(true);
        getCandidate(candidateId).then((resp) => {
          setCandidate(resp);
          setIsLoading(false);
        });
      } else if (storeCandidate.candidate !== null) {
        setIsLoading(true);
        setCandidate(storeCandidate.candidate);
        setIsLoading(false);
      }
    }
  }, [candidateId]);

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.html(document.querySelector(".cv-container"), {
      callback: (doc) => doc.save("resume.pdf"),
    });
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <div className="loading-container">
          <CircularProgress />
          <div>Chargement du cv en cours...</div>
        </div>
      ) : (
        <>
          <div className="template-page fit-to-page">
            <style>
              {`
                  
          body {
  padding: 0;
  margin: 0;
  background-color: white;
}

@page {
    margin: 10mm;
}

.fit-to-page {
    height: calc(100vh - 20mm);
}

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.margin {
  width: 699px;
  margin: 0 auto;
}

.cv-base {
  width: 800px;
  height: 1052px;
  margin: 45px auto;
  background-color: transparent;
  position: relative;
}

.cv-base .back {
  z-index: 1;
  width: 100%;
  height: 100%;
  transform: rotate(4deg);
  background-color: #007CB5;
  position: absolute;
  overflow: hidden;
  top: 0;
}

.cv-base .front {
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: white;
  position: relative;
  overflow: hidden;
}

.cv-base .front header {
  width: 100%;
  height: 310px;
  padding-bottom: 5px;
  margin-bottom: 5px;
  background-color: transparent;
  position: relative;
  overflow: hidden;
}


.cv-base .front header .head-top {
  width: 100%;
  height: 68px;
  z-index: 1;
  -webkit-transform: rotate(1deg);
  -moz-transform: rotate(1deg);
  -ms-transform: rotate(1deg);
  -o-transform: rotate(1deg);
  transform: rotate(1deg);
  background-color: #007CB5;
  position: absolute;
  overflow: hidden;
  top: -16px;
}

.cv-base .front header .head-right {
  width: 497px;
  height: 373px;
  z-index: 3;
  -webkit-transform: rotate(22deg);
  -moz-transform: rotate(22deg);
  -ms-transform: rotate(22deg);
  -o-transform: rotate(22deg);
  transform: rotate(22deg);
  -webkit-box-shadow: 0 1px 12px -4px #292929;
  -moz-box-shadow: 0 1px 12px -4px #292929;
  box-shadow: 0 1px 12px -4px #292929;
  background-color: #292929;
  position: absolute;
  overflow: hidden;
  top: -288px;
  right: -98px;
}


.cv-base .front header .head-bottom {
  z-index: 2;
  width: 100%;
  height: 254px;
  padding: 13px 0 0 0;
  background-color: transparent;
  position: absolute;
  overflow: hidden;
  top: 55px;
}


.cv-base .front header .head-bottom .image-left {
  float: left;
  width: 220px;
  height: 220px;
  margin-right: 44px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background-color: #292929;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  background-size: cover;
  overflow: hidden;
}


.cv-base .front header .head-bottom .words-right {
  float: left;
  height: 201px;
  padding: 66px 0 0 0;
  background-color: transparent;
}

.cv-base .front header .head-bottom .words-right h3 {
  padding: 12px 40px 9px 46px;
  margin: 0 0 0 0;
  position: relative;
  border-radius: 100px;
  display: inline-block;
  background-color: #292929;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 25px;
  color: #efefef;
}

.cv-base .front header .head-bottom .words-right p {
  padding: 7px 0 0 3px;
  margin: 0;
  text-transform: capitalize;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-size: 19px;
  color: #292929;
}

.cv-base .front header .head-bottom .words-right h3:before {
  content: "";
  width: 50px;
  height: 17px;
  background-color: #292929;
  position: absolute;
  bottom: -16px;
  right: 0;
}

.cv-base .front header .head-bottom .words-right h3:after {
  content: "";
  width: 23px;
  height: 17px;
  background-color: #292929;
  position: absolute;
  bottom: -16px;
  right: -27px;
}


.cv-base .front header .head-bottom .aesthetic01:before {
  content: "";
  width: 54px;
  height: 17px;
  background-color: #007CB5;
  position: absolute;
  top: 54px;
  left: 52px;
}

.cv-base .front header .head-bottom .aesthetic01:after {
  content: "";
  width: 54px;
  height: 17px;
  background-color: #007CB5;
  position: absolute;
  top: 70px;
  left: 29px;
}

.cv-base .front header .head-bottom .aesthetic02:before {
  content: "";
  width: 51px;
  height: 17px;
  background-color: #007CB5;
  position: absolute;
  top: 140px;
  left: 269px;
}

.cv-base .front header .head-bottom .aesthetic02:after {
  content: "";
  width: 26px;
  height: 17px;
  background-color: #007CB5;
  position: absolute;
  top: 140px;
  left: 237px;
}

.cv-base .front header .head-bottom .aesthetic03:before {
  content: "";
  width: 84px;
  height: 21px;
  background-color: #007CB5;
  position: absolute;
  top: 181px;
  left: 222px;
}

.cv-base section {
  width: 100%;
  height: 530.7px;
  background-color: transparent;
  overflow: hidden;
}

.cv-base section aside {
  float: left;
  width: 242px;
  height: 521.7px;
  margin-right: 20px;
  background-color: transparent;
  border-right: 1px solid #d8d8d8;
  overflow: hidden;
}

.cv-base section aside .aside-parts {
  width: 100%;
  padding-right: 10px;
  margin-bottom: 10px;
  background-color: transparent;
  overflow: hidden;
}

.cv-base section aside .aside-parts h3 {
  padding: 0 0 8px 0;
  margin: 0;
  text-align: center;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #292929;
}


.cv-base section aside .aside-parts ul {
  width: 100%;
  padding: 0;
  margin: 0;
  list-style-type: none;
  overflow: hidden;
}


.cv-base section aside .aside-parts ul li {
  width: 100%;
  margin-bottom: 10px;
  overflow: hidden;
}

.cv-base section aside .aside-parts ul li h3 {
  color: #007CB5;
}

.cv-base section aside .aside-parts ul li p {
  padding: 0;
  margin: 0;
  font-family: "Poppins", sans-serif;
  color: #777;
}


.cv-base section aside #aside01 ul {
  height: 124px;
}

.cv-base section aside #aside01 ul li p {
  line-height: 19px;
  font-size: 12px;
}


.cv-base section aside #aside02 {
  margin-bottom: 0;
}

.cv-base section aside #aside02 ul {
  height: 326.7px;
  padding-right: 8px;
}

.cv-base section aside #aside02 ul li h3 {
  padding: 0 0 3px 0;
  text-align: center;
  font-size: 15px;
}

.cv-base section aside #aside02 ul li p:first-of-type {
  padding: 0 0 3px 0;
  font-size: 14px;
  text-align: center;
  font-weight: 700;
}

.cv-base section aside #aside02 ul li p:last-of-type {
  line-height: 19px;
  font-size: 14px;
  text-align: center;
}

.cv-base section aside #aside02 ul #education01 {
  display: list-item;
  text-align: center;
}

.cv-base section aside #aside02 ul #education02 {
  display: list-item;
}

.cv-base section aside #aside02 ul #education03 {
  display: none;
}

.cv-base section aside #aside02 ul #education04 {
  display: none;
}

.cv-base section aside #aside02 ul #education05 {
  display: none;
}

.cv-base section aside #aside02 ul #education06 {
  display: none;
}

.cv-base section aside #aside02 ul #education07 {
  display: none;
}

.cv-base section aside #aside02 ul #education08 {
  display: none;
}

.cv-base section aside #aside02 ul #education09 {
  display: none;
}

.cv-base section aside #aside02 ul #education10 {
  display: none;
}

.cv-base section aside #aside02 ul #education11 {
  display: none;
}

.cv-base section aside #aside02 ul #education12 {
  display: none;
}

.cv-base section aside #aside02 ul #education13 {
  display: none;
}

.cv-base section aside #aside02 ul #education14 {
  display: none;
}

.cv-base section aside #aside02 ul #education15 {
  display: none;
}

.cv-base section aside #aside02 ul #education16 {
  display: none;
}

.cv-base section aside #aside02 ul #education17 {
  display: none;
}

.cv-base section aside #aside02 ul #education18 {
  display: none;
}

.cv-base section aside #aside02 ul #education19 {
  display: none;
}

.cv-base section aside #aside02 ul #education20 {
  display: none;
}

.cv-base section aside #aside02 ul #education21 {
  display: none;
}

.cv-base section aside #aside02 ul #education22 {
  display: none;
}

.cv-base section aside #aside02 ul #education23 {
  display: none;
}

.cv-base section aside #aside02 ul #education24 {
  display: none;
}

.cv-base section aside #aside02 ul #education25 {
  display: none;
}

.cv-base section aside #aside02 ul #education26 {
  display: none;
}

.cv-base section aside #aside02 ul #education27 {
  display: none;
}

.cv-base section aside #aside02 ul #education28 {
  display: none;
}

.cv-base section aside #aside02 ul #education29 {
  display: none;
}

.cv-base section aside #aside02 ul #education30 {
  display: none;
}

.cv-base section aside #aside02 ul #education31 {
  display: none;
}

.cv-base section aside #aside02 ul #education32 {
  display: none;
}

.cv-base section aside #aside02 ul #education33 {
  display: none;
}

.cv-base section article {
  float: right;
  width: 435px;
  height: 521.7px;
  background-color: transparent;
  overflow: hidden;
}

.cv-base section article .article-parts {
  width: 100%;
  margin-bottom: 18px;
  background-color: transparent;
  overflow: hidden;
}

.cv-base section article .article-parts h3 {
  padding: 0 0 10px 0;
  margin: 0;
  text-align: center;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #292929;
}

.cv-base section article .article-parts ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.cv-base section article #article01 .groups {
  width: 100%;
  height: 74px;
  padding-right: 10px;
  overflow: hidden;
}

.cv-base section article #article01 .groups .lines {
  width: 100%;
  margin-bottom: 15px;
  background-color: transparent;
  overflow: hidden;
}

.cv-base section article #article01 .groups .lines:last-child {
  margin-bottom: 0;
}

.cv-base section article #article01 .groups .lines ul li {
  float: left;
  width: 140px;
  margin-right: 5px;
  background-color: transparent;
  overflow: hidden;
}

.cv-base section article #article01 .groups .lines ul li:last-child {
  margin-right: 0;
}

.cv-base section article #article01 .groups .lines ul li .icons {
  float: left;
  width: 18px;
  padding-right: 0;
  overflow: hidden;
}

.cv-base section article #article01 .groups .lines ul li .icons i {
  font-size: 14px;
  color: #007CB5;
}


.cv-base section article #article01 .groups .lines ul li .words {
  float: right;
  width: 118px;
  padding-top: 3px;
  padding-left: 3px;
  overflow: hidden;
  
}

.cv-base section article #article01 .groups .lines ul li .words p {
  padding: 0;
  margin: 0;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  color: #777;
}


.cv-base section article #article01 .groups #line01 {
  display: inline-block;
}

.cv-base section article #article01 .groups #line02 {
  display: inline-block;
}

.cv-base section article #article01 .groups #line03 {
  display: none;
}

.cv-base section article #article01 .groups #line04 {
  display: none;
}

.cv-base section article #article01 .groups #line05 {
  display: none;
}

.cv-base section article #article01 .groups #line06 {
  display: none;
}


.cv-base section article #article01 .groups #line01 ul li:first-child {
  display: list-item;
}

.cv-base section article #article01 .groups #line01 ul li:nth-child(2) {
  display: list-item;
}

.cv-base section article #article01 .groups #line01 ul li:last-child {
  display: list-item;
}


.cv-base section article #article01 .groups #line02 ul li:first-child {
  display: list-item;
}

.cv-base section article #article01 .groups #line02 ul li:nth-child(2) {
  display: list-item;
}

.cv-base section article #article01 .groups #line02 ul li:last-child {
  display: list-item;
}


.cv-base section article #article01 .groups #line03 ul li:first-child {
  display: none;
}

.cv-base section article #article01 .groups #line03 ul li:nth-child(2) {
  display: none;
}

.cv-base section article #article01 .groups #line03 ul li:last-child {
  display: none;
}


.cv-base section article #article01 .groups #line04 ul li:first-child {
  display: none;
}

.cv-base section article #article01 .groups #line04 ul li:nth-child(2) {
  display: none;
}

.cv-base section article #article01 .groups #line04 ul li:last-child {
  display: none;
}


.cv-base section article #article01 .groups #line05 ul li:first-child {
  display: none;
}

.cv-base section article #article01 .groups #line05 ul li:nth-child(2) {
  display: none;
}

.cv-base section article #article01 .groups #line05 ul li:last-child {
  display: none;
}


.cv-base section article #article01 .groups #line06 ul li:first-child {
  display: none;
}

.cv-base section article #article01 .groups #line06 ul li:nth-child(2) {
  display: none;
}

.cv-base section article #article01 .groups #line06 ul li:last-child {
  display: none;
}


.cv-base section article #article02 {
  margin-bottom: 0;
}

.cv-base section article #article02 ul {
  height: 367px;
  padding-right: 10px;
  overflow: hidden;
}

.cv-base section article #article02 ul li {
  width: 100%;
  margin-bottom: 10px;
  overflow: hidden;
}

.cv-base section article #article02 ul li h3 {
  padding: 0 0 3px 0;
  text-align: left;
  font-size: 15px;
  color: #007CB5;
}

.cv-base section article #article02 ul li p:first-of-type {
  padding: 0 0 3px 0;
  margin: 0 0 0 0;
  font-family: "Poppins", sans-serif;
  font-size: 15px;
  color: #777;
  font-weight: 700;
}

.cv-base section article #article02 ul li p:last-of-type {
  padding: 0;
  margin: 0;
  font-family: "Poppins", sans-serif;
  line-height: 19px;
  font-size: 12px;
  color: #777;
  
}

.cv-base section article #article02 ul #experience01 {
  display: list-item;
}

.cv-base section article #article02 ul #experience02 {
  display: list-item;
}

.cv-base section article #article02 ul #experience03 {
  display: list-item;
}

.cv-base section article #article02 ul #experience04 {
  display: none;
}

.cv-base section article #article02 ul #experience05 {
  display: none;
}

.cv-base section article #article02 ul #experience06 {
  display: none;
}

.cv-base section article #article02 ul #experience07 {
  display: none;
}

.cv-base section article #article02 ul #experience08 {
  display: none;
}

.cv-base section article #article02 ul #experience09 {
  display: none;
}

.cv-base section article #article02 ul #experience10 {
  display: none;
}

.cv-base section article #article02 ul #experience11 {
  display: none;
}

.cv-base section article #article02 ul #experience12 {
  display: none;
}

.cv-base section article #article02 ul #experience13 {
  display: none;
}

.cv-base section article #article02 ul #experience14 {
  display: none;
}

.cv-base section article #article02 ul #experience15 {
  display: none;
}

.cv-base section article #article02 ul #experience16 {
  display: none;
}

.cv-base section article #article02 ul #experience17 {
  display: none;
}

.cv-base section article #article02 ul #experience18 {
  display: none;
}

.cv-base section article #article02 ul #experience19 {
  display: none;
}

.cv-base section article #article02 ul #experience20 {
  display: none;
}

.cv-base section article #article02 ul #experience21 {
  display: none;
}

.cv-base section article #article02 ul #experience22 {
  display: none;
}

.cv-base section article #article02 ul #experience23 {
  display: none;
}

.cv-base section article #article02 ul #experience24 {
  display: none;
}

.cv-base section article #article02 ul #experience25 {
  display: none;
}

.cv-base section article #article02 ul #experience26 {
  display: none;
}

.cv-base section article #article02 ul #experience27 {
  display: none;
}

.cv-base section article #article02 ul #experience28 {
  display: none;
}

.cv-base section article #article02 ul #experience29 {
  display: none;
}

.cv-base section article #article02 ul #experience30 {
  display: none;
}

.cv-base section article #article02 ul #experience31 {
  display: none;
}

.cv-base section article #article02 ul #experience32 {
  display: none;
}

.cv-base section article #article02 ul #experience33 {
  display: none;
}


.cv-base .loop {
  width: 100%;
  height: 212px;
  z-index: 1;
  -webkit-transform: rotate(-16deg);
  -moz-transform: rotate(-16deg);
  -ms-transform: rotate(-16deg);
  -o-transform: rotate(-16deg);
  transform: rotate(-16deg);
  background-color: #007CB5;
  position: absolute;
  bottom: -106px;
  left: 55px;
}


.cv-base .front footer {
  width: 100%;
  height: 207px;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  z-index: 2;
}

.cv-base .front footer .foot-back {
  width: 86%;
  height: 222px;
  z-index: 1;
  -webkit-transform: rotate(7deg);
  -moz-transform: rotate(7deg);
  -ms-transform: rotate(7deg);
  -o-transform: rotate(7deg);
  transform: rotate(7deg);
  background-color: #292929;
  position: absolute;
  overflow: hidden;
  bottom: -98px;
  left: -43px;
}

.cv-base .front footer .foot-front {
  width: 345px;
  height: 205px;
  z-index: 2;
  -webkit-transform: rotate(28deg);
  -moz-transform: rotate(28deg);
  -ms-transform: rotate(28deg);
  -o-transform: rotate(28deg);
  transform: rotate(28deg);
  background-color: #292929;
  position: absolute;
  overflow: hidden;
  bottom: -193px;
  right: -133px;
}

.cv-base .front footer .foot-words {
  z-index: 3;
  width: 639px;
  height: 115px;
  padding: 8px 0 0 49px;
  background-color: transparent;
  position: absolute;
  overflow: hidden;
  top: 91px;
  left: 0;
}

.cv-base .front footer .foot-words h3 {
  padding: 0 0 13px 0;
  margin: 0;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #efefef;
}

.cv-base .front footer .foot-words ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.cv-base .front footer .foot-words ul li {
  float: left;
    margin-right: 20px;
    margin-left: 10px;
  margin-bottom: 14px;
  background-color: transparent;
  overflow: hidden;
}


.cv-base .front footer .foot-words ul li .icons {
  float: left;
  width: 20px;
  overflow: hidden;
}

.cv-base .front footer .foot-words ul li .icons i {
  font-size: 16px;
  color: #007CB5;
}

.cv-base .front footer .foot-words ul li .words {
  
  overflow: hidden;
}

.cv-base .front footer .foot-words ul li .words p {
  
  padding: 0;
  margin: 0;
  overflow: hidden;
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  color: #efefef;
}
  .cv-base .front footer .foot-words ul li .words p #contact02{
    margin: 18px;
  }


.cv-base .back, .cv-base .front, .cv-base .front footer .foot-back {
  -webkit-box-shadow: 0 0 12px -4px #000;
  -moz-box-shadow: 0 0 12px -4px #000;
  box-shadow: 0 0 12px -4px #000;
}

.cv-base .front header .head-bottom .words-right h3:before, .cv-base .front header .head-bottom .words-right h3:after, .cv-base .front header .head-bottom .aesthetic01:before, .cv-base .front header .head-bottom .aesthetic01:after, .cv-base .front header .head-bottom .aesthetic02:before, .cv-base .front header .head-bottom .aesthetic02:after, .cv-base .front header .head-bottom .aesthetic03:before {
  -webkit-border-radius: 100px;
  -moz-border-radius: 100px;
  border-radius: 100px;
}

          .button-container {
            position: fixed;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            flex-direction: column;
            gap: 10px;
          }

          .btn {
              padding: 12px 20px;
              font-size: 16px;
              cursor: pointer;
              border: none;
              border-radius: 5px;
              color: #fff;
              background-color: #333;
          }

          .btn-download {
              background-color: #5cb85c;
          }
                    
        /* Media Queries for Print */
        @media print {
            body {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            
            .button-container, .footer {
              display: none;
            }
          


        }


      `}
            </style>
            <div className="cv-base">
              <div className="back"></div>
              <div className="front">
                <header>
                  <div className="head-top"></div>
                  <div className="head-right"></div>
                  <div className="head-bottom">
                    <div className="margin">
                      <div
                        className="image-left"
                        style={{
                          backgroundImage: `url(${candidate?.profilePictureUrl})`,
                        }}
                      ></div>
                      <div className="words-right">
                        <h3>
                          {candidate?.firstName} {candidate?.lastName}
                        </h3>
                      </div>
                    </div>
                    <div className="aesthetic01"></div>
                    <div className="aesthetic02"></div>
                    <div className="aesthetic03"></div>
                  </div>
                </header>
                <section>
                  <div className="margin">
                    <aside>
                      <div id="aside01" className="aside-parts">
                        <h3>Sommaire</h3>
                        <div
                          className="html-content summary-content"
                          dangerouslySetInnerHTML={{
                            __html: candidate?.summary,
                          }}
                        />
                      </div>

                      <div id="aside02" className="aside-parts">
                        <h3>Parcours scolaire</h3>
                        <ul id="scrolls">
                          {candidate?.educations.map((edu, index) => (
                            <li id="education01">
                              <h3>
                                {moment(edu?.startYear).format("YYYY")}-
                                {moment(edu?.endYear).format("YYYY")}
                              </h3>
                              <p>{edu?.degree}</p>

                              <p>{edu?.description}</p>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </aside>
                    <article>
                      <div id="article01" className="article-parts">
                        <h3>Compétences Professionnelles</h3>
                        <div id="scrolls" className="groups">
                          <div id="line01" className="lines">
                            <ul>
                              {candidate?.skills.map((skill, index) => (
                                <li key={index}>
                                  <div className="icons">
                                    <i className="fas fa-star"></i>
                                  </div>
                                  <div className="words">
                                    <p>{skill?.title}</p>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div id="article02" className="article-parts">
                        <h3>Expérience Professionnelle</h3>
                        <ul id="scrolls">
                          {candidate?.workExperiences.map((job, index) => (
                            <li id="experience01">
                              <h3>{moment(job?.startDate).format("YYYY")}</h3>
                              <p>{job?.title}</p>
                              <p>{job?.description}</p>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </article>
                  </div>
                </section>
                <div className="loop"></div>
                <footer>
                  <div className="foot-back"></div>
                  <div className="foot-front"></div>
                  <div className="foot-words">
                    <h3>Contactez-moi</h3>
                    <ul>
                      <li id="contact01">
                        <div className="icons">
                          <i className="fas fa-map-marker-alt"></i>
                        </div>
                        <div className="words">
                          <p title="">{candidate?.birthPlace}</p>
                        </div>
                      </li>
                      <li id="contact02">
                        <div className="icons">
                          <i className="fas fa-envelope"></i>
                        </div>
                        <div className="words">
                          <p>{candidate?.email}</p>
                        </div>
                      </li>
                      <li id="contact03">
                        <div className="icons">
                          <i className="fas fa-phone"></i>
                        </div>
                        <div className="words">
                          <p>{candidate?.phoneNumber1}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </footer>
              </div>
            </div>

            <div className="button-container">
              <button className="btn btn-print" onClick={() => window.print()}>
                Imprimer mon CV
              </button>
              <button className="btn btn-download" onClick={downloadPDF}>
                Télécharger le PDF
              </button>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

ResumeTemplate2.propTypes = {
  storeCandidate: PropTypes.object.isRequired,
  getCandidate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  storeCandidate: state.candidate,
});

export default connect(mapStateToProps, { getCandidate })(ResumeTemplate2);
